import FW from '../../fw/fw';
import Logger from '../../fw/logger';

export default class AWSMediaTailor {

  #rmp;
  #adOnStage = false;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  get adOnStage() {
    return this.#adOnStage;
  }

  #adStartedUpdateUI(event) {
    try {
      Logger.print('shaka-player', 'AWS Media Tailor: ad', event.ad);
      this.#rmp.shakaAd = event.ad;
      if (this.#rmp.shakaAd && this.#rmp.shakaAd.isLinear()) {
        this.#rmp.rmpAdsHelpers.addCountDown();
        if (this.#rmp.adShowRemainingTime) {
          this.#rmp.rmpAdsHelpers.appendRemainingTimeBar();
        }
        this.#rmp.adUI = true;
        this.#adOnStage = true;
      }
    } catch (warning) {
      console.warn(warning);
    }
  }

  #adStoppedUpdateUI() {
    this.#rmp.adUI = false;
    this.#adOnStage = false;
  }

  #attachShakaAdEvents() {
    const Utils = window.shaka.ads.Utils;

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_BREAK_READY, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_BREAK_READY');
      this.#rmp.dispatch('adbreakready');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_PROGRESS, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_PROGRESS');
      this.#rmp.dispatch('adprogress');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_BUFFERING, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_BUFFERING');
      this.#rmp.dispatch('adbuffering');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_LOADED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_LOADED');
      this.#rmp.dispatch('adloaded');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_IMPRESSION, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_IMPRESSION');
      //this.#adStartedUpdateUI(e);
      this.#rmp.dispatch('adimpression');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_STARTED, (e) => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_STARTED');
      this.#adStartedUpdateUI(e);
      this.#rmp.dispatch('adstarted');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_DURATION_CHANGED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_DURATION_CHANGED');
      this.#rmp.dispatch('addurationchange');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_FIRST_QUARTILE, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_FIRST_QUARTILE');
      this.#rmp.dispatch('adfirstquartile');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_MIDPOINT, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_MIDPOINT');
      this.#rmp.dispatch('admidpoint');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_THIRD_QUARTILE, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_THIRD_QUARTILE');
      this.#rmp.dispatch('adthirdquartile');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_COMPLETE, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_COMPLETE');
      this.#rmp.dispatch('adcomplete');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_STOPPED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_STOPPED');
      this.#adStoppedUpdateUI();
      this.#rmp.dispatch('adstopped');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_CLOSED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_CLOSED');
      this.#rmp.dispatch('aduserclose');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_ERROR, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_ERROR');
      this.#rmp.dispatch('aderror');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_PAUSED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_PAUSED');
      this.#rmp.dispatch('adpaused');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_RESUMED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_RESUMED');
      this.#rmp.dispatch('adresumed');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_CLICKED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_CLICKED');
      this.#rmp.dispatch('adclick');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_MUTED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_MUTED');
      this.#rmp.dispatch('advolumemuted');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_VOLUME_CHANGED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_VOLUME_CHANGED');
      this.#rmp.dispatch('advolumechanged');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_SKIPPED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_SKIPPED');
      this.#rmp.dispatch('adskipped');
    });

    this.#rmp.shakaAdManager.addEventListener(Utils.AD_SKIP_STATE_CHANGED, () => {
      Logger.print('shaka-player', 'AWS Media Tailor: AD_SKIP_STATE_CHANGED');
      this.#rmp.dispatch('adskippablestatechanged');
    });
  }

  async load() {
    Logger.print('shaka-player', 'AWS Media Tailor: Preparing stream');
    const mediaTailorContainer = document.createElement('div');
    mediaTailorContainer.className = 'rmp-ad-shaka-media-tailor-container';
    FW.insertBefore(this.#rmp.dom.content.parentNode, mediaTailorContainer, this.#rmp.dom.content.nextSibling);
    const netEngine = this.#rmp.shakaPlayer.getNetworkingEngine();
    this.#rmp.shakaAdManager = this.#rmp.shakaPlayer.getAdManager();
    this.#rmp.shakaAdManager.initMediaTailor(mediaTailorContainer, netEngine, this.#rmp.dom.video);
    if (this.#rmp.shakaAWSMediaTailorTrackingUrl) {
      this.#rmp.shakaAdManager.addMediaTailorTrackingUrl(this.#rmp.shakaAWSMediaTailorTrackingUrl);
    }
    this.#attachShakaAdEvents();
    if (this.#rmp.adCountDown) {
      if (!this.#rmp.dom.adInfo) {
        this.#rmp.rmpAdsHelpers.createControlBarAdInfo();
      }
    }
    let uri;
    if (!FW.isEmptyObject(this.#rmp.shakaAWSMediaTailorAdsParam)) {
      Logger.print('shaka-player', 'mediaTailorAdsParams: Preparing stream', this.#rmp.shakaAWSMediaTailorAdsParam);
      try {
        uri = await this.#rmp.shakaAdManager.requestMediaTailorStream(
          this.#rmp.startingSrcUri,
          this.#rmp.shakaAWSMediaTailorAdsParam
        );
      } catch (warning) {
        console.warn(warning);
      }
    } else {
      try {
        uri = await this.#rmp.shakaAdManager.requestMediaTailorStream(this.#rmp.startingSrcUri);
      } catch (warning) {
        console.warn(warning);
      }
    }

    this.#rmp.rmpShakaPlayer.loadOrPreload(uri);
  }

}
